<template>
    <div class="appcard-instance-card">
        <!-- Header -->
        <div class="appcard-header">
            <div class="appcard-icon">
                <i class="fa-solid fa-file-invoice-dollar"></i>
            </div>
            <div class="appcard-info compact-info">
                <h3 class="appcard-name">{{ data.application.user.name }}</h3>
                <div class="appcard-subtitle">{{ data.application.user.email }}</div>
            </div>
            <div class="invoice-type">
                <i class="fa-solid fa-font-awesome"></i> {{ getInvoiceTypeName(data.type) }}
            </div>
            <div :class="['appcard-status', data.status]">
                <span class="fa-solid" :class="getStatusIcon(data.status)"></span>
                {{ getInvoiceStatusName(data.status) }}
            </div>
        </div>

        <!-- Details -->
        <div class="invoice-table">
            <div class="invoice-cell">
                <div class="invoice-value">
                    {{ data.application_name }}
                    {{ data.description || 'Descripción de la Aplicación' }} </div>
            </div>
            <div class="invoice-cell">
                <div class="invoice-label">
                    <i class="fa-regular fa-calendar-plus"></i>
                    Fecha de emisión
                </div>
                <div class="invoice-value">{{ getFormatDate(data.issue_date) }}</div>
            </div>

            <div class="invoice-cell">
                <div class="invoice-label">
                    <i class="fa-regular fa-calendar-plus"></i>
                    Fecha de vencimiento
                </div>
                <div class="invoice-value">{{ getFormatDate(data.due_date) }}</div>
            </div>

            <div class="invoice-cell">
                <div class="invoice-label">
                    <i class="fa-solid fa-circle-dollar"></i>
                    Cantidad
                </div>
                <div class="invoice-value">
                    $ {{ isNaN(parseFloat(data.amount)) ? '0.00' : parseFloat(data.amount).toFixed(2) }}
                </div>
            </div>
        </div>

        <!-- Actions -->
        <div class="appcard-actions">
            <ArgonButton size="sm" color="primary" variant="gradient" @click="$emit('edit-record', data)">
                <span class="fa-solid fa-pen-to-square" /> Editar
            </ArgonButton>

            <ArgonButton
v-if="!data.deleted_at" size="sm" color="danger" variant="gradient"
                @click="$emit('delete-record', data)">
                <span class="fa-solid fa-trash" /> Eliminar
            </ArgonButton>

            <ArgonButton
v-if="data.deleted_at" size="sm" color="success" variant="gradient"
                @click="$emit('restore-record', data)">
                <span class="fa-solid fa-rotate-left" /> Restaurar
            </ArgonButton>
        </div>
    </div>
</template>

<script setup>
import ArgonButton from '@/components/ArgonButton.vue'
import { getFormatDate } from '@/utils/globalFunctions'
import { invoiceType, invoiceStatus } from '@/data/menuvalues.js'

defineProps({ data: Object })

function getInvoiceTypeName(typeId) {
    const found = invoiceType.find(t => t.id === typeId)
    return found ? found.name : '-'
}

function getInvoiceStatusName(statusId) {
    const found = invoiceStatus.find(t => t.id === statusId)
    return found ? found.name : '-'
}

function getStatusIcon(status) {
    switch (status) {
        case 'pending':
            return 'fa-clock text-warning'
        case 'paid':
            return 'fa-circle-check text-success'
        case 'cancelled':
            return 'fa-circle-xmark text-danger'
        default:
            return 'fa-question-circle text-secondary'
    }
}
</script>

<style scoped>
@import '@/assets/css/AppCard.css';

.appcard-status.pending {
    background: #fef9c3;
    color: #b45309;
    border-color: #fde68a;
}

.appcard-status.paid {
    background: #ecfdf5;
    color: #10b981;
    border-color: #10b981;
}

.appcard-status.cancelled {
    background: #fee2e2;
    color: #dc2626;
    border-color: #dc2626;
}

.invoice-type {
    background: linear-gradient(to right, #f1f5f9, #e2e8f0);
    font-weight: 600;
    padding: 0.45rem 1.25rem;
    border: 1px solid #cbd5e1;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
}

.invoice-type:hover {
    transform: translateY(-2px);
}

.invoice-table {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 20px;
    padding: 20px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    font-family: 'Inter', sans-serif;
}

.invoice-cell {
    display: flex;
    flex-direction: column;
    background: #f9fafb;
    padding: 16px;
    border-radius: 12px;
    transition: background 0.3s ease;
}

.invoice-cell:hover {
    background: #eef1f6;
    cursor: pointer;
}

.invoice-label {
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.invoice-value {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
}
</style>